/**
 * PDPVideo Component
 * Handles video playback and integration with product carousels
 */

// Import the base class and implementation
import PDPVideo from './PDPVideoClass';
import './PDPVideoImplementation';

// Re-export utility functions for potential use elsewhere
export * from './VideoUtils';

// Export the default class
export default PDPVideo;
